import { Page, type DispatchedAction } from '@eo/shared';

import { settingsController } from './controller';
import { SettingsContent } from './SettingsContent';
import type { SettingsState } from './types';

export default function SettingsPage() {
  return (
    <Page<SettingsState> controller={settingsController as never}>
      {({ data, actions }) => (
        <SettingsContent
          data={data}
          onSaveClickup={(payload) => actions.saveClickup(payload) as Promise<DispatchedAction>}
          onRemoveClickup={() => actions.removeClickup(undefined) as Promise<DispatchedAction>}
          onSaveGranola={(payload) => actions.saveGranola(payload) as Promise<DispatchedAction>}
          onRemoveGranola={() => actions.removeGranola(undefined) as Promise<DispatchedAction>}
          onDisconnectGoogle={() =>
            actions.disconnectGoogle(undefined) as Promise<DispatchedAction>
          }
          onDisconnectSlack={() => actions.disconnectSlack(undefined) as Promise<DispatchedAction>}
        />
      )}
    </Page>
  );
}
